import React from 'react'
import classnames from 'classnames'
import ConditionalLink from './conditional-link'
import Icon from './icon'

const MenuLink = ({name, to, valid = false, children}) => (
  <li 
    className={classnames({
      'navigation-link': true,
      [`navigation-link__${name}`]: true,
      'navigation-link__invalid': !valid
    })}
  >
    <ConditionalLink 
      to={to}
      valid={valid}
    >
      <Icon title={name} />
      {children}
    </ConditionalLink>
  </li>
)

export default MenuLink


// WEBPACK FOOTER //
// ./src/onboarding/nav/views/link.jsx